var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pc-shopping-list-pages"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_vm._m(0)],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c(_vm.dynamicComponent,{tag:"component"})
}]

export { render, staticRenderFns }